import _ from 'lodash';

export const asTag = (tag) => _.get(tag, 'fields.semanticKey');

export const asTags = (tags) => (tags || []).map(asTag).filter(Boolean);
